export default {"src":"/_next/static/media/document-icon.a005fb9b.svg","height":72,"width":72};